import http from "../http";

const EditFlightService = {

    getSelectedFlight: async (id) => {
        const flight = await http.instance.get("/Schedule/GetNetlineFlightByLEGNO/", {params: {LEG_NO: id}});
        return flight.data;
    },

    getSelectedFlightByKfnl: async (FKeyForNetline)=> {
      const flight = await http.instance.get("/Schedule/GetNetlineFlightByKFNL/",{params:{FKeyForNetline: FKeyForNetline}});
      return flight.data;
    },

    // getSelectedFlightByKeyForZip: async (fKeyForZip,std) => {
    //     const flight = await http.instance.get("/Schedule/GetFilterFlightByFkeyForZip/", {params: {FkeyForZip: fKeyForZip,Std:std}});
    //     return flight.data;
    // },

    getSelectedFlightByLegNo : async(std,legno) => {

        const flight = await http.instance.get("/Schedule/GetFilterFlightByLegNo/", {params: {LegNo: legno,Std:std}});
        return flight.data;
    },

    editFlightForm: async (form) => {
        const edit = await http.instance.post("/Schedule/Edit", form);
        return edit.data
    },

    editFlightForceLockmodeOff_Sync : (form) =>
    {
        const edit = http.instance.post("/Schedule/WhoEditNetlineFlight/", form);
        return edit.data
    },

    createFlightForm : async (form) =>
    {
        const edit = await http.instance.post("/Schedule", form);
        return edit.data
    }

};
export default EditFlightService;
